<template>
  <div class="screening-check-result-dialog">
    <dialog-header
      class="screening-check-result-dialog-header"
      v-model="headerTitle"
      @close="onDialogClose"
    ></dialog-header>
    <div
      v-if="showFilter"
      class="screening-check-result-dialog-search"
    >
      <div class="screening-check-result-dialog-search-label">姓名/病案号</div>
      <div class="screening-check-result-dialog-search-box">
        <input
          v-model.trim="keyword"
          class="screening-check-result-dialog-search-input"
          placeholder=""
          @keyup.enter="onSearch"
        />
        <button
          class="screening-check-result-dialog-search-btn"
          type="button"
          @click="onSearch"
        >
          搜索
        </button>
      </div>
    </div>
    <div class="screening-check-result-dialog-list">
      <div class="screening-check-result-dialog-list-title">
        <span style="flex: 1">姓名</span>
        <span style="flex: 2">手机号</span>
        <span style="flex: 3">量表名称</span>
        <span style="flex: 3">测评得分/结果</span>
        <span style="flex: 2">时间</span>
        <span style="flex: 1">操作</span>
      </div>
      <div class="screening-check-result-dialog-list-content">
        <ul class="screening-check-result-dialog-list-content-list">
          <li v-for="(report, index) in reportList" :key="index">
            <div class="screening-report-list-item">
              <div style="flex: 1">
                {{ report.name }}
              </div>
              <div style="flex: 2">
                {{ report.phone }}
              </div>
              <div style="flex: 3">
                {{ report.title }}
              </div>
              <div style="flex: 3">
                {{ report.score }}
              </div>
              <div style="flex: 2">
                {{ report.time }}
              </div>
              <div style="flex: 1; cursor: pointer; color: #325fac" @click="onCheck(report.id)">
                {{ report.type !== 35 ? "查看" : "" }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="screening-check-result-dialog-bottom">
      <div class="screening-check-result-dialog-bottom-pagination">
        <pagination v-show="total != 0" :total="total" :pageSize="pageSize" :current-page="currentPage"
          @pagechange="pagechange"></pagination>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.screening-check-result-dialog {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  min-width: rem(600);
  border-radius: 2px;

  &-header {
    width: 100%;
    height: rem(57);
  }

  &-search {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: rem(10);
    display: flex;
    align-items: center;

    &-label {
      font-size: rem(14);
      font-weight: 400;
      color: #262626;
      margin-right: rem(10);
      white-space: nowrap;
    }

    &-box {
      width: 200px;
      display: flex;
      align-items: center;
      height: rem(30);
      border: 1px solid #dcdfe6;
      border-radius: rem(6);
      overflow: hidden;
      background: #ffffff;
    }

    &-input {
      width: 120px;
      height: 100%;
      border: none;
      outline: none;
      padding: 0 rem(16);
      font-size: rem(16);
      background: transparent;
    }

    &-btn {
      height: 100%;
      padding: 0 rem(10);
      border: none;
      background: #2f5db1;
      color: #ffffff;
      font-size: rem(14);
      font-weight: 400;
      cursor: pointer;

      &:hover {
        background: #244a90;
      }
    }
  }

  &-list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: rem(20);

    &-title {
      background: #325fac;
      color: white;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      border-radius: 5px;
      width: 100%;
      height: 36px;
      display: flex;
      align-items: center;
    }

    &-content {
      width: 100%;
      height: 459px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  &-bottom {
    margin-bottom: rem(40);
  }
}

.screening-report-list-item {
  height: rem(40);
  width: 100%;
  font-size: rem(14);
  text-align: center;
  color: black;
  display: flex;
  align-items: center;

}
</style>

<script>
import { DateTool } from "@js/date-tool.js";
import Pagination from "@c/common/pagination.vue";
import dialogHeader from "@c/screening-questionnaire/screening-dialog/screening-dialog-header.vue";
import {
  getDisplayName,
  getDisplayMobile,
} from "@js/anonymization-tool.js";
export default {
  props: {
    value: String,
    taskID: Number,
    count: Number,
    hospitalID: Number,
  },
  components: {
    dialogHeader,
    Pagination,
    DateTool,
  },
  data() {
    return {
      headerTitle: this.value,
      dialogVisible: this.visibility,
      reportList: [],
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前的页数
      total: undefined, // 显示总条数
      pages: 1, //总页数
      keyword: "",
    };
  },
  methods: {
    onDialogClose(value) {
      this.$emit("close", value);
    },

    onCheck(id) {
      let routeData = this.$router.resolve({
        path: "/query-result",
        query: {
          id
        },
      });
      window.open(routeData.href, "_blank");
    },

    handleVisibilityChange() {
      // 当标签页从隐藏变为可见时，刷新数据
      if (document.visibilityState === 'visible') {
        this.onReset();
      }
    },

    onSearch() {
      this.currentPage = 1;
      this.reportListRequest();
    },

    onReset() {
      this.keyword = "";
      this.currentPage = 1;
      this.reportListRequest();
    },

    async reportListRequest() {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        taskId: this.taskID,
      };
      if (this.hospitalID === 599) {
        params.keyword = this.keyword || undefined;
      }
      try {
        const response = await this.$api.assessmentResultList(params);

        this.total = response.total;
        this.reportList = [];

        for (const reportItem of response.list) {
          var date = reportItem.gmtCreate.substring(0, 16);
          const item = {
            id: reportItem.id,
            name: getDisplayName(reportItem.trueName, this.$store.state.accountInfo),
            title: reportItem.title || '-',
            score: reportItem.type === QUERY_TYPE.CCTQ ? '—' : `${reportItem.total !== null ? reportItem.total : '--'}分${reportItem.result ? (',' + reportItem.result) : ''}`,
            time: date,
            phone: getDisplayMobile(reportItem.mobile, this.$store.state.accountInfo),
            type: reportItem.type,
          };
          if (reportItem.type !== QUERY_TYPE.CCTQ && reportItem.result && reportItem.result.length > 58) {
            item.score =
              reportItem.total + "分," + reportItem.result.slice(0, 58) + "...";
          }
          this.reportList.push(item);
        }
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    //pagination
    pagechange: function (currentPage) {
      this.currentPage = currentPage;
      this.reportListRequest();
    },
  },
  computed: {
    showFilter() { 
      return this.hospitalID === 599
    }
  },

  watch: {
    taskID(newVal) {
      // this.reportListRequest();
    },
    count(newVal) {
      this.currentPage = 1;
      this.onReset();
    },
  },
  mounted() {
    this.reportListRequest();
    // 监听标签页可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
</script>
